import { render, staticRenderFns } from "./widget-component-text.vue?vue&type=template&id=ca03acc8&scoped=true"
import script from "./widget-component-text.vue?vue&type=script&lang=ts"
export * from "./widget-component-text.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca03acc8",
  null
  
)

export default component.exports